import { render, staticRenderFns } from "./ButtonCancel.vue?vue&type=template&id=04804ff6&scoped=true"
import script from "./ButtonCancel.vue?vue&type=script&lang=js"
export * from "./ButtonCancel.vue?vue&type=script&lang=js"
import style0 from "./ButtonCancel.vue?vue&type=style&index=0&id=04804ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04804ff6",
  null
  
)

export default component.exports